import React from 'react';
import { FiStar, FiX } from 'react-icons/fi';

export default function SeleccionMasivaBar({ count, onAsignar, onQuitar, onLimpiar }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        flexWrap: 'wrap',
        padding: '10px 14px',
        borderRadius: '10px',
        background: '#e8f0fe',
        border: '1px solid #c6d4f5',
        marginBottom: '10px',
      }}
    >
      <span style={{ fontSize: '13px', fontWeight: 600, color: '#1a3a7a' }}>
        {count} producto(s) seleccionado(s)
      </span>
      <div style={{ flex: 1 }} />
      <button
        onClick={onAsignar}
        style={{
          padding: '6px 14px',
          borderRadius: '8px',
          border: 'none',
          background: '#0d904f',
          color: '#fff',
          cursor: 'pointer',
          fontSize: '13px',
          fontWeight: 600,
        }}
      >
        <FiStar size={14} style={{ marginRight: '4px', verticalAlign: 'middle' }} />
        Asignar etiqueta
      </button>
      <button
        onClick={onQuitar}
        style={{
          padding: '6px 14px',
          borderRadius: '8px',
          border: '1px solid #dadce0',
          background: '#fff',
          color: '#5f6368',
          cursor: 'pointer',
          fontSize: '13px',
          fontWeight: 600,
        }}
      >
        Quitar etiqueta
      </button>
      <button
        onClick={onLimpiar}
        title="Limpiar selección"
        style={{
          padding: '6px',
          borderRadius: '8px',
          border: 'none',
          background: 'transparent',
          color: '#5f6368',
          cursor: 'pointer',
        }}
      >
        <FiX size={16} />
      </button>
    </div>
  );
}
